import type { TaxType } from '@shared/modules/tax-types/tax-type';
import { Presenter } from '@shared/presenters/presenter';

export class TaxTypePresenter extends Presenter<TaxType> {

}
